import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authService } from '../services/auth.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';
import type { SignupData } from '../types/auth.types';

export function useSignup() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (data: SignupData) => authService.signup(data),
    onSuccess: () => {
      navigate('/success/account/signup');
    },
    onError: (err: Error) => {
      console.error('[Signup] Error:', err);
      // Use centralized error message handler for proper translation
      setError(getApiErrorMessage(err));
    },
  });

  const signup = async (data: SignupData) => {
    setError(null);
    return mutation.mutateAsync(data);
  };

  return {
    signup,
    isLoading: mutation.isPending,
    error,
    clearError: () => setError(null),
  };
}
